import Swiper, { Navigation } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-downloads-carousel]',
};

class DownloadsCarousel extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.carouselWrappers = document.querySelectorAll(
        selectors.carouselWrapper
      );

      this.initCarousels();
    });
  }

  initCarousels() {
    this.carousel = new Swiper(selectors.carouselWrapper, {
      modules: [Navigation],
      freeMode: true,
      slidesPerView: 'auto',
      spaceBetween: 30,
      watchOverflow: true,
      slidesOffsetAfter: 150,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
}

customElements.define('downloads-carousel', DownloadsCarousel);
